// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Gi6-","content":"styles_content__20Ude"};